import { render } from "./StudentHome.vue?vue&type=template&id=1de84a74&scoped=true"
import script from "./StudentHome.vue?vue&type=script&lang=js"
export * from "./StudentHome.vue?vue&type=script&lang=js"

import "./StudentHome.vue?vue&type=style&index=0&id=1de84a74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de84a74"]])

export default __exports__